(function ($) {
    $.fn.hoverScroll = function (options) {
        var $parent = options.parent,
            $arrowRight = $parent.children('.arrow-right'),
            $arrowLeft = $parent.children('.arrow-left'),
            $container = $(this),
            productThumbWidth = $container.children().width(),
            childCount = $container.children().length,
            parentWidth = $parent.width(),
            scrollWidth = (childCount * productThumbWidth);

        // sets CSS class hide scroll bar if scroll bars not needed for touch and non-touch interfaces
        if (scrollWidth <= parentWidth) {
            $parent.addClass('no-scroller');
        }

        // Simple hover scrolling effect for non-touch interfaces, relys on modernzr no-touch
        if ($('html').hasClass('no-touch')) {
            $arrowRight.hover(
                function () {
                    continuousScroll($container, "right", "linear", 7);
                },
                function () {
                    stopScroll($container);
                }
            );
            $arrowLeft.hover(
                function () {
                    continuousScroll($container, "left", "linear", 7);
                },
                function () {
                    stopScroll($container);
                }
            );
        }
    }

    function continuousScroll($container, $direction, $easing, $speed) {
        var $elementWidth = $container.children().width(),
            $elementCount = $container.children().length,
            $fullScrollLength = $elementWidth * $elementCount,
            $scrollPosition = $container.scrollLeft();

        if ($direction == "right") {
            var $scrollDistance = $fullScrollLength - $scrollPosition,
                $scrollSpeed = $speed * $scrollDistance;
            $container.animate({ scrollLeft: $scrollPosition + $scrollDistance }, $scrollSpeed, $easing);
        }
        else {
            var $scrollDistance = $scrollPosition,
                $scrollSpeed = $speed * $scrollDistance;
            $container.animate({ scrollLeft: 0 }, $scrollSpeed, $easing);
        }
    }

    function stopScroll($container) {
        $container.stop();
    }
})(jQuery);